import * as R from 'ramda';
import { createSelector } from 'reselect';
// report-common
import { getReportSelectors } from '../../report-common';
//////////////////////////////////////////////////

const {
  store,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} = getReportSelectors('geoFencingLocation');

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => R.sortBy(R.prop('index'), R.values(itemList)),
);

const makeSelectReportType = () => createSelector(
  store,
  ({ reportType }) => reportType,
);

const makeSelectCurrentLocation = () => createSelector(
  store,
  ({ currentLocation }) => currentLocation,
);

const makeSelectTrailersByLocation = () => createSelector(
  store,
  ({ trailersByLocation }) => trailersByLocation,
);

const makeSelectTrailerRouteHistory = () => createSelector(
  store,
  ({ milestoneLogList }) => milestoneLogList,
);

const makeSelectConfigs = () => createSelector(
  store,
  ({ configs }) => configs,
);

export {
  // report
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectReportType,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  // configs
  makeSelectConfigs,
  // location
  makeSelectCurrentLocation,
  // fleet/trailer
  makeSelectTrailersByLocation,
  makeSelectTrailerRouteHistory,
};
